import IconClaude from "@/app/(components)/generics/Icons/IconClaude";
import IconGmail from "@/app/(components)/generics/Icons/IconGmail";
import IconGoogleDrive from "@/app/(components)/generics/Icons/IconGoogleDrive";
import IconGoogleMeet from "@/app/(components)/generics/Icons/IconGoogleMeet";
import IconLinkedInBrand from "@/app/(components)/generics/Icons/IconLinkedInBrand";
import IconOpenAI from "@/app/(components)/generics/Icons/IconOpenAI";
import IconZoomBrand from "@/app/(components)/generics/Icons/IconZoomBrand";
import {
  FLOW_CONTACT_PHOTO,
  LANDING_IMAGES_DIR,
} from "@/app/(components)/specifics/pages/Home/components/ConceptFlow/ConceptFlow.logic";
import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { HowItWorksBlock, HowItWorksMockKind } from "@/app/types/home/HowItWorksBlock";
import {
  HowItWorksAnswerPart,
  HowItWorksBar,
  HowItWorksConnectorClient,
  HowItWorksContextItem,
  HowItWorksCustomer,
  HowItWorksDate,
  HowItWorksDot,
  HowItWorksExchangeRow,
  HowItWorksFieldDot,
  HowItWorksFileEvent,
  HowItWorksPersona,
  HowItWorksPersonaTheme,
  HowItWorksQuery,
  HowItWorksSource,
} from "@/app/types/home/HowItWorksMockData";

export const HOW_IT_WORKS_SECTION_ID = "how";

export const HOW_IT_WORKS_BLOCKS: HowItWorksBlock[] = [
  {
    mock: HowItWorksMockKind.CAPTURE,
    labelKey: TKey.HOME_MEIDLY_HOW_CAPTURE_LABEL,
    titleKey: TKey.HOME_MEIDLY_HOW_CAPTURE_TITLE,
    bulletKeys: [
      TKey.HOME_MEIDLY_HOW_CAPTURE_BULLET_1,
      TKey.HOME_MEIDLY_HOW_CAPTURE_BULLET_2,
      TKey.HOME_MEIDLY_HOW_CAPTURE_BULLET_3,
    ],
  },
  {
    mock: HowItWorksMockKind.CUSTOMER_FILE,
    labelKey: TKey.HOME_MEIDLY_HOW_FILE_LABEL,
    titleKey: TKey.HOME_MEIDLY_HOW_FILE_TITLE,
    bulletKeys: [
      TKey.HOME_MEIDLY_HOW_FILE_BULLET_1,
      TKey.HOME_MEIDLY_HOW_FILE_BULLET_2,
      TKey.HOME_MEIDLY_HOW_FILE_BULLET_3,
    ],
  },
  {
    mock: HowItWorksMockKind.PERSONA,
    labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_LABEL,
    titleKey: TKey.HOME_MEIDLY_HOW_PERSONA_TITLE,
    bulletKeys: [
      TKey.HOME_MEIDLY_HOW_PERSONA_BULLET_1,
      TKey.HOME_MEIDLY_HOW_PERSONA_BULLET_2,
      TKey.HOME_MEIDLY_HOW_PERSONA_BULLET_3,
    ],
  },
  {
    mock: HowItWorksMockKind.ASSISTANT,
    labelKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_LABEL,
    titleKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_TITLE,
    bulletKeys: [
      TKey.HOME_MEIDLY_HOW_ASSISTANT_BULLET_1,
      TKey.HOME_MEIDLY_HOW_ASSISTANT_BULLET_2,
      TKey.HOME_MEIDLY_HOW_ASSISTANT_BULLET_3,
    ],
  },
  {
    mock: HowItWorksMockKind.CONNECTORS,
    labelKey: TKey.HOME_MEIDLY_HOW_CONNECTORS_LABEL,
    titleKey: TKey.HOME_MEIDLY_HOW_CONNECTORS_TITLE,
    bulletKeys: [
      TKey.HOME_MEIDLY_HOW_CONNECTORS_BULLET_1,
      TKey.HOME_MEIDLY_HOW_CONNECTORS_BULLET_2,
      TKey.HOME_MEIDLY_HOW_CONNECTORS_BULLET_3,
    ],
  },
];

const TODAY: HowItWorksDate = { key: TKey.HOME_MEIDLY_HOW_DATE_TODAY };
const YESTERDAY: HowItWorksDate = { key: TKey.HOME_MEIDLY_HOW_DATE_YESTERDAY };
const daysAgo = (count: number): HowItWorksDate => ({
  key: TKey.HOME_MEIDLY_HOW_DATE_DAYS_AGO,
  count,
});

export const HOW_CAPTURE_LIVE: HowItWorksExchangeRow = {
  Icon: IconGoogleMeet,
  company: "Nordvik Logistique",
  titleKey: TKey.HOME_MEIDLY_HOW_EX_BUDGET,
  date: TODAY,
  typeKey: TKey.EXCHANGE_TYPE_NEGOTIATION,
};

export const HOW_CAPTURE_ROWS: HowItWorksExchangeRow[] = [
  {
    Icon: IconZoomBrand,
    company: "Transports Arlo",
    titleKey: TKey.HOME_MEIDLY_HOW_EX_DEMO,
    date: TODAY,
    typeKey: TKey.EXCHANGE_TYPE_DEMO,
  },
  {
    Icon: IconGmail,
    company: "Maison Verlaine",
    titleKey: TKey.HOME_MEIDLY_HOW_EX_QUOTE_FOLLOW_UP,
    date: YESTERDAY,
    typeKey: TKey.EXCHANGE_TYPE_FOLLOW_UP,
  },
  {
    Icon: IconLinkedInBrand,
    company: "Atelier Kerno",
    titleKey: TKey.HOME_MEIDLY_HOW_EX_FIRST_CONTACT,
    date: YESTERDAY,
    typeKey: TKey.EXCHANGE_TYPE_DISCOVERY,
  },
  {
    Icon: IconGoogleDrive,
    company: "Groupe Salvan",
    titleKey: TKey.HOME_MEIDLY_HOW_EX_COMMITTEE,
    date: daysAgo(2),
    typeKey: TKey.EXCHANGE_TYPE_NEGOTIATION,
  },
];

export const HOW_FILE_CUSTOMER: HowItWorksCustomer = {
  name: "Claire Morel",
  company: "Nordvik Logistique",
  photo: FLOW_CONTACT_PHOTO,
};

export const HOW_FILE_AVATAR_SIZE = 44;

export const HOW_FILE_EVENTS: HowItWorksFileEvent[] = [
  {
    Icon: IconGoogleMeet,
    titleKey: TKey.HOME_MEIDLY_HOW_EX_BUDGET,
    date: TODAY,
    metrics: { customerShare: 62, interruptions: 2 },
    passage: {
      labelKey: TKey.EXCHANGE_TAG_OBJECTION,
      quoteKey: TKey.HOME_MEIDLY_HOW_PASSAGE_1,
      toneClass: "toneObjection",
    },
  },
  {
    Icon: IconGmail,
    titleKey: TKey.HOME_MEIDLY_HOW_EX_QUOTE_FOLLOW_UP,
    date: YESTERDAY,
    commitment: {
      actionKey: TKey.HOME_MEIDLY_HOW_COMMITMENT_1,
      dueKey: TKey.HOME_MEIDLY_HOW_COMMITMENT_1_DUE,
      isOverdue: true,
    },
  },
  {
    Icon: IconZoomBrand,
    titleKey: TKey.HOME_MEIDLY_HOW_EX_DEMO,
    date: daysAgo(5),
    deal: {
      titleKey: TKey.HOME_MEIDLY_HOW_DEAL_1,
      stageKey: TKey.DEAL_STAGE_WON,
      toneClass: "won",
    },
  },
];

export const HOW_PERSONA: HowItWorksPersona = {
  photos: [
    `${LANDING_IMAGES_DIR}contact-1.jpg`,
    `${LANDING_IMAGES_DIR}contact-3.jpg`,
    `${LANDING_IMAGES_DIR}contact-2.jpg`,
  ],
  customers: 12,
  winRate: 67,
};

export const HOW_PERSONA_AVATAR_SIZE = 36;

export const HOW_PERSONA_THEMES: HowItWorksPersonaTheme[] = [
  {
    tagKey: TKey.EXCHANGE_TAG_PAIN_POINT,
    toneClass: "tonePain",
    dotClass: "dotPain",
    labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_PAIN_1,
    value: 10,
  },
  {
    tagKey: TKey.EXCHANGE_TAG_BUYING_REASON,
    toneClass: "toneSignal",
    dotClass: "dotSignal",
    labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_REASON_1,
    value: 9,
  },
  {
    tagKey: TKey.EXCHANGE_TAG_OBJECTION,
    toneClass: "toneObjection",
    dotClass: "dotObjection",
    labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_BRAKE_1,
    value: 7,
  },
];

export const HOW_PERSONA_MORE_THEMES = "+16";

export const HOW_PERSONA_QUERIES: HowItWorksQuery[] = [
  {
    titleKey: TKey.HOME_MEIDLY_HOW_PERSONA_QUERY_SEARCH,
    criteria: [
      {
        labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_1_LABEL,
        valueKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_1,
      },
      {
        labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_2_LABEL,
        valueKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_2,
      },
      {
        labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_3_LABEL,
        valueKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_3,
      },
    ],
    moreCount: 5,
  },
  {
    titleKey: TKey.HOME_MEIDLY_HOW_PERSONA_QUERY_QUALIFY,
    criteria: [
      {
        labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_4_LABEL,
        valueKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_4,
      },
      {
        labelKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_7_LABEL,
        valueKey: TKey.HOME_MEIDLY_HOW_PERSONA_CRITERION_7,
      },
    ],
    moreCount: 4,
  },
];

export function personaShare(label: string, count: number): string {
  return withCount(label, count).replace("{{total}}", String(HOW_PERSONA.customers));
}

export function personaDots(filled: number): HowItWorksDot[] {
  return Array.from({ length: HOW_PERSONA.customers }, (_, index) => ({
    id: `dot${index}`,
    isFilled: index < filled,
  }));
}

export const HOW_ASSISTANT_ANSWER: HowItWorksAnswerPart[] = [
  { textKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_ANSWER_1, cite: 1 },
  { textKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_ANSWER_2, cite: 2 },
];

export const HOW_ASSISTANT_BARS: HowItWorksBar[] = [
  { labelKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_BAR_1, value: 9 },
  { labelKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_BAR_2, value: 6 },
  { labelKey: TKey.HOME_MEIDLY_HOW_ASSISTANT_BAR_3, value: 4 },
];

export const HOW_ASSISTANT_SOURCES: HowItWorksSource[] = [
  { index: 1, customer: "Hugo Lefèvre", company: "Transports Arlo" },
  { index: 2, customer: "Sarah Benali", company: "Maison Verlaine" },
];

export const HOW_CONNECTORS_CLIENTS: HowItWorksConnectorClient[] = [
  { Icon: IconClaude, name: "Claude", colorClass: "brandClaude" },
  { Icon: IconOpenAI, name: "ChatGPT", colorClass: "brandOpenAI" },
];

export const HOW_CONNECTORS_CONTEXT: HowItWorksContextItem[] = [
  {
    labelKey: TKey.HOME_MEIDLY_HOW_CONNECTORS_CONTEXT_1,
    toneClass: "tonePain",
    dotClass: "dotPain",
  },
  {
    labelKey: TKey.HOME_MEIDLY_HOW_CONNECTORS_CONTEXT_2,
    toneClass: "toneObjection",
    dotClass: "dotObjection",
  },
  {
    labelKey: TKey.HOME_MEIDLY_HOW_CONNECTORS_CONTEXT_3,
    toneClass: "toneNeutral",
    dotClass: "dotKept",
  },
];

const HOW_CONNECTORS_FIELD_SIZE = 72;

const HOW_CONNECTORS_KEPT: Record<number, string> = {
  9: "dotPain",
  22: "dotObjection",
  39: "dotObjection",
  50: "dotKept",
  65: "dotKept",
};

export function connectorDots(): HowItWorksFieldDot[] {
  return Array.from({ length: HOW_CONNECTORS_FIELD_SIZE }, (_, index) => ({
    id: `field${index}`,
    dotClass: HOW_CONNECTORS_KEPT[index] ?? null,
  }));
}

export const HOW_CONNECTORS_ANSWER: TKey[] = [
  TKey.HOME_MEIDLY_HOW_CONNECTORS_ANSWER_1,
  TKey.HOME_MEIDLY_HOW_CONNECTORS_ANSWER_2,
];

export function formatMockDate(date: HowItWorksDate, t: TFn): string {
  const label = t(date.key);
  return date.count === undefined ? label : label.replace("{{count}}", String(date.count));
}

export function sellerShare(customerShare: number): number {
  return 100 - customerShare;
}

export function percentWidth(share: number): string {
  return `${share}%`;
}

export function talkLabel(label: string, customerShare: number): string {
  return withCount(label, customerShare).replace("{{seller}}", String(sellerShare(customerShare)));
}

export function withCount(label: string, count: number): string {
  return label.replace("{{count}}", String(count));
}

export function barShare(value: number, bars: HowItWorksBar[]): string {
  const max = Math.max(...bars.map((bar) => bar.value));
  return max > 0 ? `${(value / max) * 100}%` : "0%";
}
